<template>
  <div class="top">
    <div class="filter">
      <AreaCascader
        v-if="endLevel != -1"
        v-model="areaCodeList"
        :end-level="endLevel"
        @confirm="onAreaCodeChange"
        @clear="onAreaCodeChange"
        :initArea="initArea"
        checkStrictly
      />
      <span v-else>{{areaName}}</span>
    </div>
    <div class="cards">
      <div class="card block">
        <div class="title">房源总数</div>
        <div class="content">{{ bulletinBoardData.roomCount }}</div>
      </div>
      <div class="card block">
        <div class="title">经营者总数</div>
        <div class="content">{{ bulletinBoardData.managerCount }}</div>
      </div>
      <div class="card block">
        <div class="title">累计入住人数</div>
        <div class="content">{{ bulletinBoardData.checkInCount }}</div>
      </div>
      <div class="card block">
        <div class="title">当前入住人数</div>
        <div class="content">{{ bulletinBoardData.stayingCount }}</div>
      </div>
      <div class="card block">
        <div class="title">设备数量</div>
        <div class="content">
          <span>{{ bulletinBoardData.onlineDeviceCount }}</span
          >/{{ bulletinBoardData.deviceTotalCount }}
        </div>
      </div>
    </div>
  </div>
  <div class="block-list">
    <div class="block">
      <div class="header">
        <span>房源统计（TOP10）</span>
        <span class="more" @click="$router.push('/roomInfo')">详情分布</span>
      </div>
      <div class="charts">
        <div id="chart1" class="chart"></div>
      </div>
    </div>
    <div class="block">
      <div class="header">
        <span>入住统计（TOP10）</span>
        <span class="more" @click="$router.push('/orderInfo')">详情分布</span>
      </div>
      <div class="charts">
        <div id="chart2" class="chart"></div>
      </div>
    </div>
    <div class="block">
      <div class="header">
        <span>客源地城市及占比（TOP10）</span>
      </div>
      <div class="charts">
        <div id="chart3" class="chart"></div>
      </div>
    </div>
  </div>
  <div class="block-list">
    <div class="block">
      <div class="header">
        <span>智能设备</span>
        <span class="more" @click="$router.push('/equip/doorLock')">详情分布</span>
      </div>
      <div class="charts">
        <div class="line">
          <div class="item">
            <img src="@/assets/img/lock.png" alt="" />
            <div class="name">智能门锁</div>
          </div>
          <div class="item">
            <div class="title">安装房源数</div>
            <div class="content">
              {{ deviceStatisticData[103] ? deviceStatisticData[103].installRoomCount : 0 }}
            </div>
          </div>
          <div class="item">
            <div class="title">未安装房源数</div>
            <div class="content">
              {{ deviceStatisticData[103] ? deviceStatisticData[103].unInstallRoomCount : 0 }}
            </div>
          </div>
          <div class="item">
            <div class="title">安装率</div>
            <div class="content">{{ deviceStatisticData[103] ? deviceStatisticData[103].rate : 0 }}</div>
          </div>
          <div class="item">
            <div class="title">设备在线率</div>
            <div class="content">
              {{ deviceStatisticData[103] ? deviceStatisticData[103].deviceOnlinePercent : 0 }}
            </div>
          </div>
        </div>
        <div class="line">
          <div class="item">
            <img src="@/assets/img/ring.png" alt="" />
            <div class="name">智能门铃</div>
          </div>
          <div class="item">
            <div class="title">安装房源数</div>
            <div class="content">
              {{ deviceStatisticData[104] ? deviceStatisticData[104].installRoomCount : 0}}
            </div>
          </div>
          <div class="item">
            <div class="title">未安装房源数</div>
            <div class="content">
              {{ deviceStatisticData[104] ? deviceStatisticData[104].unInstallRoomCount : 0 }}
            </div>
          </div>
          <div class="item">
            <div class="title">安装率</div>
            <div class="content">{{ deviceStatisticData[104] ? deviceStatisticData[104].rate : 0 }}</div>
          </div>
          <div class="item">
            <div class="title">设备在线率</div>
            <div class="content">
              {{ deviceStatisticData[104] ? deviceStatisticData[104].deviceOnlinePercent : 0 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="header">
        <span>入住人员趋势</span>
        <span class="more" @click="reset">重置</span>
      </div>
      <div class="charts">
        <div id="chart4" class="chart"></div>
      </div>
    </div>
    <div class="block">
      <div class="header">
        <span>客户画像</span>
      </div>
      <div class="charts" style="display: flex">
        <div v-show="chart5" id="chart5" style="width: 200px; height: 400px"></div>
        <div v-show="chart6" id="chart6" style="width: 200px; height: 400px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import setChart from "./setChart.js";
import { mapActions, mapState } from "vuex";
import AreaCascader from "@/components/common/areaCascader";
export default {
  data() {
    return {
      chart5: null,
      chart6: null,
      areaCodeList: "",
      options: [
        {
          value: "guide",
          label: "Guide",
          children: [
            {
              value: "disciplines",
              label: "Disciplines",
              children: [
                {
                  value: "consistency",
                  label: "Consistency",
                },
                {
                  value: "feedback",
                  label: "Feedback",
                },
                {
                  value: "efficiency",
                  label: "Efficiency",
                },
                {
                  value: "controllability",
                  label: "Controllability",
                },
              ],
            },
            {
              value: "navigation",
              label: "Navigation",
              children: [
                {
                  value: "side nav",
                  label: "Side Navigation",
                },
                {
                  value: "top nav",
                  label: "Top Navigation",
                },
              ],
            },
          ],
        },
        {
          value: "component",
          label: "Component",
          children: [
            {
              value: "basic",
              label: "Basic",
              children: [
                {
                  value: "layout",
                  label: "Layout",
                },
                {
                  value: "color",
                  label: "Color",
                },
                {
                  value: "typography",
                  label: "Typography",
                },
                {
                  value: "icon",
                  label: "Icon",
                },
                {
                  value: "button",
                  label: "Button",
                },
              ],
            },
            {
              value: "form",
              label: "Form",
              children: [
                {
                  value: "radio",
                  label: "Radio",
                },
                {
                  value: "checkbox",
                  label: "Checkbox",
                },
                {
                  value: "input",
                  label: "Input",
                },
                {
                  value: "input-number",
                  label: "InputNumber",
                },
                {
                  value: "select",
                  label: "Select",
                },
                {
                  value: "cascader",
                  label: "Cascader",
                },
                {
                  value: "switch",
                  label: "Switch",
                },
                {
                  value: "slider",
                  label: "Slider",
                },
                {
                  value: "time-picker",
                  label: "TimePicker",
                },
                {
                  value: "date-picker",
                  label: "DatePicker",
                },
                {
                  value: "datetime-picker",
                  label: "DateTimePicker",
                },
                {
                  value: "upload",
                  label: "Upload",
                },
                {
                  value: "rate",
                  label: "Rate",
                },
                {
                  value: "form",
                  label: "Form",
                },
              ],
            },
            {
              value: "data",
              label: "Data",
              children: [
                {
                  value: "table",
                  label: "Table",
                },
                {
                  value: "tag",
                  label: "Tag",
                },
                {
                  value: "progress",
                  label: "Progress",
                },
                {
                  value: "tree",
                  label: "Tree",
                },
                {
                  value: "pagination",
                  label: "Pagination",
                },
                {
                  value: "badge",
                  label: "Badge",
                },
              ],
            },
            {
              value: "notice",
              label: "Notice",
              children: [
                {
                  value: "alert",
                  label: "Alert",
                },
                {
                  value: "loading",
                  label: "Loading",
                },
                {
                  value: "message",
                  label: "Message",
                },
                {
                  value: "message-box",
                  label: "MessageBox",
                },
                {
                  value: "notification",
                  label: "Notification",
                },
              ],
            },
            {
              value: "navigation",
              label: "Navigation",
              children: [
                {
                  value: "menu",
                  label: "Menu",
                },
                {
                  value: "tabs",
                  label: "Tabs",
                },
                {
                  value: "breadcrumb",
                  label: "Breadcrumb",
                },
                {
                  value: "dropdown",
                  label: "Dropdown",
                },
                {
                  value: "steps",
                  label: "Steps",
                },
              ],
            },
            {
              value: "others",
              label: "Others",
              children: [
                {
                  value: "dialog",
                  label: "Dialog",
                },
                {
                  value: "tooltip",
                  label: "Tooltip",
                },
                {
                  value: "popover",
                  label: "Popover",
                },
                {
                  value: "card",
                  label: "Card",
                },
                {
                  value: "carousel",
                  label: "Carousel",
                },
                {
                  value: "collapse",
                  label: "Collapse",
                },
              ],
            },
          ],
        },
        {
          value: "resource",
          label: "Resource",
          children: [
            {
              value: "axure",
              label: "Axure Components",
            },
            {
              value: "sketch",
              label: "Sketch Templates",
            },
            {
              value: "docs",
              label: "Design Documentation",
            },
          ],
        },
      ],
      bulletinBoardData: {},
      deviceStatisticData: {},
    };
  },
  components: { AreaCascader },
  methods: {
    ...mapActions(["fetchData"]),
    reset() {
      this.getCheckInTrendByWeek();
    },
    handleChange(value) {
      console.log(value);
    },
    setChart1(yAxis = [], data = []) {
      setChart("#chart1", {
        grid: {
          left: '0',
          right: '5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: yAxis,
        },
        series: [
          {
            type: "bar",
            data,
          },
        ],
      });
    },
    setChart2(yAxis = [], data = []) {
      setChart("#chart2", {
        // 完整显示label
        grid: {
          left: '0',
          right: '5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: yAxis,
        },
        series: [
          {
            type: "bar",
            data,
          },
        ],
      });
    },
    setChart3(yAxis = [], data = []) {
      setChart("#chart3", {
        grid: {
          left: '0',
          right: '5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: yAxis,
        },
        series: [
          {
            type: "bar",
            data,
          },
        ],
      });
    },
    setChart4(xAxis = [], data = [], moreData = []) {
      setChart(
        "#chart4",
        {
          tooltip: {
            trigger: "axis",
            formatter: "第{b}周: {c}人",
          },
          xAxis: {
            type: "category",
            data: xAxis,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data,
              type: "line",
            },
          ],
        },
        [
          {
            eventName: "click",
            handler: (params, chart) => {
              const { dataIndex } = params;
              console.log(dataIndex, moreData[dataIndex]);
              this.getCheckInTrendByDay(moreData[dataIndex].dateRange).then(
                (res) => {
                  chart.setOption({
                    xAxis: {
                      type: "category",
                      data: res ? res.map((e) => e.dayNo) : [],
                    },
                    series: [
                      {
                        data: res ? res.map((e) => e.totalCount) : [],
                      },
                    ],
                    tooltip: {
                      trigger: "axis",
                      formatter: "{b}: {c}人",
                    },
                  });
                }
              );
            },
          },
        ]
      );
    },
    setChart5(male, female) {
      setChart("#chart5", {
        title: {
          text: "性别分布",
          left: "center",
          top: "47%",
          textStyle: {
            align: "center",
          },
        },
        legend: {
          top: "5%",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              show: false,
            },
            data: [
              { value: male, name: "男" },
              { value: female, name: "女" },
            ],
          },
        ],
      });
    },
    setChart6(range1, range2, range3, range4, range5) {
      setChart("#chart6", {
        title: {
          text: "年龄分布",
          left: "center",
          top: "47%",
          textStyle: {
            align: "center",
          },
        },
        legend: {
          top: "5%",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              show: false,
            },
            data: [
              { value: range1, name: "0-17岁" },
              { value: range2, name: "18-30岁" },
              { value: range3, name: "30-40岁" },
              { value: range4, name: "40-60岁" },
              { value: range5, name: "60岁以上" },
            ],
          },
        ],
      });
    },
    getBulletinBoard() {
      this.fetchData({
        url: "ADMIN.BULLETIN_BOARD",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: {
          areaCode: this.areaCode,
        },
      }).then((res) => {
        this.bulletinBoardData = res;
      });
    },
    getCheckInStatistic() {
      this.fetchData({
        url: "ADMIN.CHECK_IN_STATISTIC",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: {
          areaCode: this.areaCode,
        },
      }).then((res) => {
        if(res && Array.isArray(res)) res.reverse();
        const showArr = res && res.map(e => {
          return e.showType === 1 ? e.areaName : e.managerName
        })
        this.setChart2(
          showArr,
          res && res.map((e) => e.orderCount)
        );
      });
    },
    getCheckInTrendByDay(dateRange) {
      return this.fetchData({
        url: "ADMIN.CHECK_IN_TREND_BY_DAY",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: {
          areaCode: this.areaCode,
          dateRange,
        },
      });
    },
    getCheckInTrendByWeek() {
      this.fetchData({
        url: "ADMIN.CHECK_IN_TREND_BY_WEEK",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: {
          areaCode: this.areaCode,
        },
      }).then((res) => {
        this.setChart4(
          res && res.map((e) => e.weekNo),
          res && res.map((e) => e.totalCount),
          res
        );
      });
    },
    getCustomerPortraitStatistic() {
      this.fetchData({
        url: "ADMIN.CUSTOMER_PORTRAIT_STATISTIC",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: {
          areaCode: this.areaCode,
        },
      }).then((res) => {
        this.chart5 = res.sexDTO;
        this.chart6 = res.ageRangeDTO;
        this.setChart5(res.sexDTO ? res.sexDTO.maleCount : 0, res.sexDTO ? res.sexDTO.femaleCount : 0);
        this.setChart6(
          res.ageRangeDTO ? res.ageRangeDTO.range1 : 0,
          res.ageRangeDTO ? res.ageRangeDTO.range2 : 0,
          res.ageRangeDTO ? res.ageRangeDTO.range3 : 0,
          res.ageRangeDTO ? res.ageRangeDTO.range4 : 0,
          res.ageRangeDTO ? res.ageRangeDTO.range5 : 0,
        );
      });
    },
    getCustomerStatistic() {
      this.fetchData({
        url: "ADMIN.CUSTOMER_STATISTIC",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: {
          areaCode: this.areaCode,
        },
      }).then((res) => {
        if(res && Array.isArray(res)) res.reverse();
        this.setChart3(
          res && res.map((e) => e.cityName),
          res && res.map((e) => e.peopleCount)
        );
      });
    },
    getDeviceStatistic() {
      this.fetchData({
        url: "ADMIN.DEVICE_STATISTIC",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: {
          areaCode: this.areaCode,
        },
      }).then((res) => {
        this.deviceStatisticData = res.reduce((acu, e) => {
          console.log(e);
          // deviceType 103-门锁，104-门铃
          let rate =
            e.installRoomCount / (e.installRoomCount + e.unInstallRoomCount);
          rate = Math.round(rate * 10000) / 100;
          acu[e.deviceType] = {
            ...e,
            rate: `${rate}%`,
          };
          return acu;
        }, {});
      });
    },
    getRoomStatistic() {
      this.fetchData({
        url: "ADMIN.ROOM_STATISTIC",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: {
          areaCode: this.areaCode,
        },
      }).then((res) => {
        if(res && Array.isArray(res)) res.reverse();
        this.roomStatisticData = res;
        const showArr = res && res.map(e => {
          return e.showType === 1 ? e.areaName : e.managerName
        })
        this.setChart1(
          showArr,
          res && res.map((e) => e.roomCount)
        );
      });
    },
    onAreaCodeChange() {
      this.getBulletinBoard();
      this.getCheckInStatistic();
      this.getCheckInTrendByWeek();
      this.getCustomerPortraitStatistic();
      this.getCustomerStatistic();
      this.getDeviceStatistic();
      this.getRoomStatistic();
    },
  },
  mounted() {
    this.getBulletinBoard();
    this.getCheckInStatistic();
    this.getCheckInTrendByWeek();
    this.getCustomerPortraitStatistic();
    this.getCustomerStatistic();
    this.getDeviceStatistic();
    this.getRoomStatistic();
    this.setChart1();
    this.setChart2();
    this.setChart3();
    this.setChart5();
    this.setChart6();
  },
  computed: {
    ...mapState({
      user: (state) => state.common.user,
    }),
    endLevel(){
      if(this.user.areaNationwide){
        return 2;
      }else{
        const {province, city, region, streetOffice, neighborCmm} = this.user;
        if(!neighborCmm){
          if(!streetOffice){
            if(!region){
              if(!city){
                return 3;
              }
              return 2;
            }
            return 1;
          }
          return 0;
        }
        return -1;
      }
    },
    initArea(){
      if(this.user.areaNationwide){
        return 0;
      }else{
        return this.user.area;
      }
    },
    areaName(){
      const {province, city, region, streetOffice, neighborCmm} = this.user;
      return `${province} ${city} ${region} ${streetOffice} ${neighborCmm}`;
    },
    areaCode() {
      if (this.areaCodeList && this.areaCodeList.length) {
        return this.areaCodeList[this.areaCodeList.length - 1];
      }
      return "";
    },
  },
};
</script>

<style scoped lang="less">
.block {
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 1px 1px 2px 0px rgba(82, 90, 102, 0.04),
    2px 2px 8px 0px rgba(82, 90, 102, 0.08);
  padding: 24px;
}
.top {
  background-color: white;
  padding: 16px;
  .filter {
    display: flex;
    margin-bottom: 16px;
  }
  .cards {
    display: flex;
    justify-content: space-between;
    .card {
      flex: 1;
      margin-right: 16px;
      &:last-child {
        margin-right: 0;
      }
      height: 180px;
      box-sizing: border-box;
      .title {
        font-size: 20px;
        color: #091136;
      }
      .content {
        font-size: 40px;
        font-weight: 600;
        color: #091136;
        text-align: center;
        margin-top: 24px;
      }
    }
    .active {
      background-color: #fcbf0c;
    }
  }
}
.block-list {
  margin: 16px 0;
  display: flex;
  .block {
    margin-right: 16px;
    flex: 1;
    &:last-child {
      margin-right: 0;
    }
    .header {
      display: flex;
      justify-content: space-between;
      .more {
        color: blue;
        cursor: pointer;
      }
    }
    .charts {
      .chart {
        height: 400px;
      }
      .line {
        display: flex;
        background-color: #f7f9fb;
        padding: 8px 16px;
        margin: 16px 0;
        &:last-child {
          margin-bottom: 0;
        }
        .item {
          flex-grow: 1;
          img {
            margin-bottom: 8px;
            width: 60px;
          }
          .name {
          }
          .title {
            white-space: nowrap;
            font-size: 14px;
            color: #6d7278;
            padding-left: 8px;
          }
          .content {
            font-size: 26px;
            color: #262626;
            padding-left: 8px;
            border-left: 1px solid #d8d8d8;
          }
        }
      }
    }
  }
}
</style>